<template>
    <v-container class="text-xs-center"> 
        <div class="results-count">{{appointments.length}} Risultati</div>
        
        <v-layout row wrap justify-center>
            <table>
            <tr>
                <th>Nome animale</th>
                <th>Microchip</th>
                <th>Vaccino</th> 
                <th>Antiparassitario</th> 
                <th>Ingresso</th>
                <th>Uscita</th> 
                <th>Proprietario</th> 
                <th>Compatibilita</th>
            </tr>
            <tr v-for="appointment in appointments" :key="appointment.id" 
                @click="appointmentClicked(appointment)">
                <td>{{ appointment.petName }}</td>
                <td>{{ appointment.microchip }}</td>
                <td>{{ appointment.vaccinationDate | date}}</td>
                <td>{{ appointment.antiparasiticDate | date}}</td>
                <td>{{ appointment.from | datetime}}</td>
                <td>{{ appointment.to | datetime}}</td>
                <td>{{ appointment.ownerName }} {{ appointment.ownerSurname }} {{ appointment.ownerFiscalCode }} {{ ownerResidence }}</td>
                <td>{{ appointment.compatibility }}</td>
            </tr>
        </table>
        </v-layout>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Pensione',
    data: function(){
        return{
            appointments: [],
            multiselect: false,
        };
    },
    mounted: function(){
        let vm = this;
        vm.getAppointments();
    },
    methods:{
        getAppointments(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getPensioneAppointments.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.appointments = [];
                    vm.appointments = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>
<style lang="stylus" scoped>
 td{
    padding:5px;
 }
 tr:nth-child(2n){
    background:#eee;
 }
</style>